import { createStore } from 'effector';

export const $regionsOkedsModal = createStore(false);

export const $regionModal = createStore(null);

export const $districtModal = createStore(null);

export const $okedsModal = createStore(null);

export const $subOkedsModal = createStore(null);

export const $regionsOkedsData = createStore(null);
$regionsOkedsData.watch((state) => console.log('$regionsOkedsData', state));

export const $regionData = createStore(null);
$regionData.watch((state) => console.log('$regionData', state));

export const $okedsData = createStore(null);
$okedsData.watch((state) => console.log('$okedsData', state));

export const $subOkedsData = createStore(null);
$subOkedsData.watch((state) => console.log('$subOkedsData', state));

export const $districtData = createStore(null);
$districtData.watch((state) => console.log('$districtData', state));

export const $okedsModalsFilters = createStore({
  region_id: null,
  district_id: null,
  activity_id: null,
  oked_ids: [],
  project_type_ids: [],
});
